import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

const styles = {};

function SDCXReleaseNotes() {
    return (
        <React.Fragment>
            <p>
                <strong>2021-06-02</strong>: Version 4.2.0 introduces Intelligent Transport version 2 for Jet.
                Signiant's newest acceleration technology optimizes transfer speed and performance for a variety of data
                sets and environments.
            </p>
            <p>
                <strong>2021-02-23</strong>: Version 4.1.4 includes infrastructure required for upcoming features in
                Signiant Jet, as well as security and stability improvements. This upgrade is recommended for all users.
            </p>
            <p>
                <strong>2020-09-30</strong>: Version 4.0 includes a{' '}
                <a href="/jet/deployment/signiant-control">new testing utility for Signiant Jet</a> and an update to the{' '}
                <a href="/jet/general/system-requirements">
                    system requirements to remove port 80 (HTTP) as a requirement
                </a>
                . Media Shuttle IT Administrators can now assign S3 Compatible storage to Media Shuttle portals. To
                enable S3 Compatible storage on your account,{' '}
                <a href="mailto:customercare@signiant.com">contact Customer Care</a>.
            </p>
            <p>
                <strong>2020-08-30</strong>: Version 3.5.0 includes more reliable transfer behavior when sending and
                receiving files using network attached storage, and improved hot folder performance for Jet. This
                upgrade is recommended for all users.
            </p>
            <p>
                <strong>2020-07-09</strong>: Version 3.4.0 includes increased SAN stability and performance improvements
                for Signiant Jet and Media Shuttle. This upgrade is recommended for all users.
            </p>
            <p>
                <strong>2020-03-19</strong>: Version 3.3.2 includes performance improvements for Signiant Jet and
                security improvements for Media Shuttle. This upgrade is recommended for all users.
            </p>
            <p>
                <strong>2020-02-24</strong>: Version 3.3.1 includes bug fixes and performance improvements impacting
                Signiant Jet.
            </p>
            <p>
                <strong>2020-01-22</strong>: Version 3.3.0 adds enhanced job status information, including the time to
                completion and the number of files remaining in the transfer.
            </p>

            <p>
                <strong>2019-12-09</strong>: With the introduction of version 3.2.3, Media Shuttle Storage Server is now
                named Signiant SDCX Server.
            </p>

            <p>
                <strong>2019-08-23</strong>: Version 3.2.0 features the ability to test connections between two SDCX
                Servers on a given route.
            </p>

            <p>
                <strong>2019-07-10</strong>: Version 3.1.1 provides support for{' '}
                <a href="https://www.signiant.com/news/press-releases/signiant-introduces-patent-pending-intelligent-transport/">
                    Intelligent Transport
                </a>{' '}
                and adds Media Shuttle functionality to the SDCX Server.
            </p>

            <p>
                <strong>2019-04-26</strong>: Version 3.0.5 provides support for proxies between Signiant Cloud Services
                and SDCX Servers. This version includes security fixes.
            </p>

            <p>
                <strong>2019-03-29</strong>: Version 3.0.2 officially launches the Signiant SDCX Server. This version
                modifies the location of log files.
            </p>
        </React.Fragment>
    );
}

SDCXReleaseNotes.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SDCXReleaseNotes);
